import { useEffect } from "react";
import { getInitialStatusOptions } from "features/candidates/utils";

export const useInitialCandidateStatusSync = (form, hireType) => {
  useEffect(() => {
    if (!hireType || !form) return;

    const currentInitialStatus = form.getFieldValue("initialStatus");
    if (!currentInitialStatus) return;

    const availableOptions = getInitialStatusOptions(hireType);

    if (!availableOptions.some((option) => option.value === currentInitialStatus)) {
      form.setFieldValue("initialStatus", undefined);
    }
  }, [hireType, form]);
};
